import { Campaign } from '@Models';
import { EntityState, buildEntityState } from '../../EntityState';

export type CampaignsState = EntityState<Campaign[]>;

export const buildCampaignsState = (data: Partial<CampaignsState> = {}) =>
  buildEntityState<Campaign[]>(data);
